<template>
  <div>auto redirect page</div>
  <div @click="CloseHubLogin">关闭窗口</div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

onMounted(async () => {
  console.log("coming in");
  //window.close();
});

const CloseHubLogin = ()=>{
  window.opener.postMessage('closeWindow', 'http://localhost:8082');
  window.close();
}
</script>

<style>

</style>